import React, { useState, useEffect, createContext, useContext } from 'react';
import { supabase } from '../utils/supabase/client';
// Create AuthContext
const AuthContext = createContext({
  session: null,
  loading: true,
  profile: null,
  isAdmin: false,
  isSuperAdmin: false,
  setProfile: () => {},
});

export default function AuthProvider({ children }) {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState(null);

  async function fetchData(session) {
    if (session) {
      const { data } = await supabase
        .from('profiles')
        .select('*')
        .eq('id', session.user.id)
        .single();
      setProfile(data);
    }
    setLoading(false);
  }

  useEffect(() => {
    // Only need to fetch session once
    const fetchSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      setSession(session);
      await fetchData(session);
    };

    fetchSession();

    // Set up auth state change listener
    const { data: authListener } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      fetchData(session);
    });

    // Cleanup subscription on unmount
    return () => {
      authListener.subscription.unsubscribe();
    };
  }, []);

  const value = {
    session,
    loading,
    profile,
    setProfile,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);